import { createBrowserRouter, Outlet, Navigate} from 'react-router-dom'
import { RouterProvider } from 'react-router'
import Login from '../pages/login';
import RecuperarSenha from '../pages/recuperarSenha';
import RedefinirSenha from '../pages/redefinirSenha';
import {FunctionComponent} from 'react'
import Home from '../pages/home';
import Consulta from '../pages/consulta';
import Cliente from '../pages/cliente';
import Permissao from '../pages/permissao';
import RelatorioConsultaSintetica from '../pages/relatorioConsultaSintetica';
import ArquivoRegistro from '../pages/arquivoRegistro';
import Page404 from '../pages/404'
import { useGlobalState } from "./globalState/GlobalStateProvider";
import Usuario from '../pages/usuario';
import Registro from '../pages/registro';
import Consultas from '../pages/consultas';
import AlterarSenha from '../pages/alterarSenha';
import RelatorioApuracaoBilhete from '../pages/relatorioApuracaoBilhete';
import RelatorioClienteAtivo from '../pages/relatorioClienteAtivo';
import ParametroAplicacaoPage from '../pages/parametroAplicacao';
import Servico from '../pages/servico';
import Plano from '../pages/plano';
import Fatura from '../pages/fatura';
import Faturamento from '../pages/faturamento';
import Consumo from '../pages/consumo';
import MotorCreditoFormula from '../pages/motorCreditoFormula';
import MotorCreditoRegra from '../pages/motorCredito';
import ResultadoMotorCredito from '../pages/resultadoMotorCredito';
import PropostaCredito from '../pages/propostaCredito';
import ConsultaPropostaCredito from '../pages/consultaPropostaCredito';
import Franquia from '../pages/franquia';
import Notificacao from '../pages/notificacao';
import NotaFiscal from '../pages/notaFiscal';
import OpcaoConsultaLotePage from '../pages/opcaoConsultaLote';
import ConsultaLotePage from '../pages/consultaLote';
import AutenticacaoDoisFatores from '../pages/autenticacaoDoisFatores';
import MainLayout from './menu/MainLayout';
import Passkey from '../pages/passkey';
import Campanha from '../pages/campanha';
import Representante from '../pages/representante';
import DashboardRepresentante from '../pages/dashboardRepresentante';
import Perfil from '../pages/perfil';

const PermissionLayout = ( {permission} : any ) => {
    const {state} = useGlobalState();
    const hasPermission = !permission || state.user?.funcoes.includes(permission);

    return hasPermission ? <Outlet /> : <Navigate to="/404" replace />;
  };

// Rota autenticada: valida a permissão e renderiza a página.
const protectedRoute = (permission: string | undefined, path: string, element: JSX.Element) => ({
  element: <PermissionLayout permission={permission} />,
  children: [{ path, element }],
});

// Rotas autenticadas — renderizadas dentro do MainLayout (Sidebar/Topbar persistentes).
const authenticatedRoutes = [
  protectedRoute('HOME', '/home', <Home />),
  protectedRoute('CAMPANHA_VISUALIZAR', '/campanha', <Campanha />),
  protectedRoute('CONSUMO', '/consumo', <Consumo />),
  protectedRoute('CONSULTAR', '/consultar', <Consulta />),
  protectedRoute('CONSULTAR', '/consultar/:id', <Consulta />),
  protectedRoute('ARQUIVOREGISTRO_VISUALIZAR', '/arquivoregistro', <ArquivoRegistro />),
  protectedRoute('CONSULTA_VISUALIZAR', '/historico', <Consultas />),
  protectedRoute('RELATORIO_CONSULTA_SINTETICA', '/filtrarconsultasintetica', <RelatorioConsultaSintetica />),
  protectedRoute('RELATORIO_APURACAO_BILHETE', '/filtrarapuracaobilhete', <RelatorioApuracaoBilhete />),
  protectedRoute('RELATORIO_CLIENTE_ATIVO', '/filtrarclienteativo', <RelatorioClienteAtivo />),
  protectedRoute('USUARIO_VISUALIZAR', '/usuario', <Usuario />),
  protectedRoute('REGISTRO_VISUALIZAR', '/registro', <Registro />),
  protectedRoute('CLIENTE_VISUALIZAR', '/cliente', <Cliente />),
  protectedRoute('REPRESENTANTE_VISUALIZAR', '/representante', <Representante />),
  protectedRoute('DASHBOARD_REPRESENTANTE', '/dashboard-representante', <DashboardRepresentante />),
  protectedRoute('FRANQUIA_VISUALIZAR', '/franquia', <Franquia />),
  protectedRoute('PERFIL_VISUALIZAR', '/perfil', <Perfil />),
  protectedRoute('PERMISSAO_VISUALIZAR', '/permissao', <Permissao />),
  protectedRoute('USERINFO', '/alterarsenha', <AlterarSenha />),
  protectedRoute('USERINFO', '/autenticacao-dois-fatores', <AutenticacaoDoisFatores />),
  protectedRoute('PARAMETRO_VISUALIZAR', '/parametros', <ParametroAplicacaoPage />),
  protectedRoute('MOTOR_CREDITO_FORMULA_VISUALIZAR', '/formula', <MotorCreditoFormula />),
  protectedRoute('MOTOR_CREDITO_VISUALIZAR', '/motorcredito', <MotorCreditoRegra />),
  protectedRoute('RESULTADO_MOTOR_CREDITO_VISUALIZAR', '/resultadomotorcredito', <ResultadoMotorCredito />),
  protectedRoute('PROPOSTA_CREDITO_HISTORICO', '/historicoproposta', <ConsultaPropostaCredito />),
  protectedRoute('PROPOSTA_CREDITO', '/proposta', <PropostaCredito />),
  protectedRoute('PROPOSTA_CREDITO', '/proposta/:id', <PropostaCredito />),
  protectedRoute('FATURAMENTO_VISUALIZAR', '/faturamento', <Faturamento />),
  protectedRoute('FATURA_VISUALIZAR', '/fatura', <Fatura />),
  protectedRoute('SERVICO_VISUALIZAR', '/servico', <Servico />),
  protectedRoute('PLANO_VISUALIZAR', '/plano', <Plano />),
    protectedRoute('USERINFO', '/passkey', <Passkey />),
  protectedRoute('NOTIFICACAO_VISUALIZAR', '/notificacao', <Notificacao />),
  protectedRoute('OPCAO_CONSULTA_LOTE_VISUALIZAR', '/opcaoconsultalote', <OpcaoConsultaLotePage />),
  protectedRoute('CONSULTA_LOTE_VISUALIZAR', '/consultalote', <ConsultaLotePage />),
  protectedRoute('NOTA_FISCAL_VISUALIZAR', '/nota-fiscal', <NotaFiscal />),
];

const router = createBrowserRouter([
    // Rotas públicas (sem Sidebar/Topbar).
    protectedRoute(undefined, '/', <Login />),
    protectedRoute(undefined, '/login', <Login />),
    protectedRoute(undefined, '/recuperacao', <RecuperarSenha />),
    protectedRoute(undefined, '/redefinir/:hash', <RedefinirSenha />),

    // Rotas autenticadas dentro do layout persistente.
    {
      element: <MainLayout />,
      children: authenticatedRoutes,
    },

    // Fallback.
    protectedRoute(undefined, '/404', <Page404 />),
    protectedRoute(undefined, '*', <Page404 />),
  ],{ basename: '/app' });

  const RouterCustom: FunctionComponent = () => {
    return <RouterProvider router={router} />;
  };

  export default RouterCustom;
